import React from 'react';
import { Link, Route, Switch, useParams} from 'react-router-dom';

import { accountService } from '../_services';

import { List } from './reservations/List';

function ReservationList({ history, match }) {
  const { path } = match;
  let { listType } = useParams();
  const user = accountService.userValue;

  return (

          <div className="card m-3">
          <Switch>
              <Route path="/reservations/:listType" component={List} />
          </Switch>
          </div>
 
  );
}

export { ReservationList };